export const Album = [
	{ id: '1', 
	imageName: 'Landschaft/Alpenquerung_auf_der_E5.jpg',
	tag: 'Landschaft', 
	title: 'Alpenquerung auf der E5',
	},

	{ id: '2', 
	imageName: 'Landschaft/Iguacú:Brasilien.jpg',
	tag: 'Landschaft', 
	title: 'Iguacú - Brasilien'
	},

	{ id: '3', 
	imageName: 'Landschaft/Fernando_Noronha:Brasilien.jpg',
	tag: 'Landschaft', 
	title: 'Fernando Noronha - Brasilien'
	},

	{ id: '4', 
	imageName: 'Landschaft/Ilha_Grande:Brasilien.jpg',
	tag: 'Landschaft', 
	title: 'Ilha_Grande - Brasilien'
	},

	{ id: '5', 
	imageName: 'Landschaft/Lencois:Brasilien.jpg',
	tag: 'Landschaft', 
	title: 'Lencois - Brasilien'
	},

	{ id: '6', 
	imageName: 'Landschaft/Rio_Negro:Brasilien.jpg',
	tag: 'Landschaft', 
	title: 'Rio Negro - Brasilien'
	},

	{ id: '7', 
	imageName: 'Landschaft/Beagle_Kanal:Argentinien.jpg',
	tag: 'Landschaft', 
	title: 'Beagle Kanal - Argentinien'
	},

	{ id: '8', 
	imageName: 'Landschaft/Gltescherabbruch:Argentinien.jpg',
	tag: 'Landschaft', 
	title: 'Gltescherabbruch - Argentinien'
	},

	{ id: '9', 
	imageName: 'Landschaft/Iguassu:Argentinien.jpg',
	tag: 'Landschaft', 
	title: 'Iguassu - Argentinien'
	},

	{ id: '10', 
	imageName: 'Landschaft/El_Tatio:Chile.jpg',
	tag: 'Landschaft', 
	title: 'El Tatio - Chile'
	},

	{ id: '11', 
	imageName: 'Landschaft/Lagune_Miniques:Chile.jpg',
	tag: 'Landschaft', 
	title: 'Lagune Miniques - Chile'
	},

	{ id: '12', 
	imageName: 'Landschaft/Vulkan_Miscantes:Chile.jpg',
	tag: 'Landschaft', 
	title: 'Vulkan Miscantes - Chile'
	},

	{ id: '13', 
	imageName: 'Landschaft/salte_Grande:Chile.jpg',
	tag: 'Landschaft', 
	title: 'Salte Grande - Chile'
	},

	{ id: '14', 
	imageName: 'Landschaft/Torres_del_Paine_Park:Chile.jpg',
	tag: 'Landschaft', 
	title: 'Torres del Paine Park - Chile'
	},

	{ id: '15', 
	imageName: 'Landschaft/Giant_Causewway:Nordirland.jpg',
	tag: 'Landschaft', 
	title: 'Giant Causewway - Nordirland'
	},

	{ id: '16', 
	imageName: 'Landschaft/Herbst_in_Köln_2:Deutschland.jpg',
	tag: 'Landschaft', 
	title: 'Herbst in Köln - Deutschland'
	},
	{ id: '17', 
	imageName: 'Landschaft/Herbst_in_Köln:Deutschland.jpg',
	tag: 'Landschaft', 
	title: 'Herbst in Köln - Deutschland'
	},
	{ id: '18', 
	imageName: 'Landschaft/Sahara:Marokko.jpg',
	tag: 'Landschaft', 
	title: 'Sahara - Marokko'
	},


	{ id: '19', 
	imageName: 'Fauna/Albatros:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Albatros - Galapagos.jpg'
	},
	{ id: '20', 
	imageName: 'Fauna/Fregattvögel:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Fregattvögel - Galapagos'
	},
	{ id: '21', 
	imageName: 'Fauna/Schildkröte:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Schildkröte - Galapagos'
	},
	{ id: '22', 
	imageName: 'Fauna/Meeresechse:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Meeresechse - Galapagos'
	},
	{ id: '23', 
	imageName: 'Fauna/Meersschildkröte:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Meersschildkröte - Galapagos'
	},
	{ id: '24', 
	imageName: 'Fauna/Seelöwe:Galapagos.jpg',
	tag: 'Natur', 
	title: 'Seelöwe - Galapagos.jpg'
	},
	{ id: '25', 
	imageName: 'Fauna/Ipé_amarelo:Brasilien.jpg',
	tag: 'Natur', 
	title: 'Ipé amarelo - Brasilien'
	},
	{ id: '26', 
	imageName: 'Fauna/Pantanal:Brasilien.jpg',
	tag: 'Natur', 
	title: 'Pantanal - Brasilien'
	},
	{ id: '27', 
	imageName: 'Fauna/Alpha_Bulle:Argentinien.jpg',
	tag: 'Natur', 
	title: 'Alpha Bulle - Argentinien'
	},
	{ id: '28', 
	imageName: 'Fauna/Iguassu:Argentinien.jpg',
	tag: 'Natur', 
	title: 'Iguassu - Argentinien'
	},
	{ id: '29', 
	imageName: 'Fauna/Flamingos:Chile.jpg',
	tag: 'Natur', 
	title: 'Flamingos - Chile'
	},
	{ id: '30', 
	imageName: 'Fauna/Regenwald:Ecuador.jpg',
	tag: 'Natur', 
	title: 'Regenwald - Ecuador'
	},


	{ id: '31', 
	imageName: 'People/Bahiana-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Bahiana - Brasilien'
	},
	{ id: '32', 
	imageName: 'People/Brasilia_2.jpg',
	tag: 'Kultur', 
	title: 'Brasilia - Brasilien'
	},
	{ id: '33', 
	imageName: 'People/Brasilia.jpg',
	tag: 'Kultur', 
	title: 'Brasilia - Brasilien'
	},	
	{ id: '34', 
	imageName: 'People/Landarbeiter-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Landarbeiter - Brasilien'
	},	
	{ id: '35', 
	imageName: 'People/Karneva-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Karneva - Brasilien'
	},
	{ id: '36', 
	imageName: 'People/Karneval2-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Karneva - Brasilien'
	},
	{ id: '37', 
	imageName: 'People/Karneval3-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Karneva - Brasilien'
	},
	{ id: '38', 
	imageName: 'People/Karneval4-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Karneva - Brasilien'
	},	
	{ id: '39', 
	imageName: 'People/Karnevalstar-Brasilien.jpg',
	tag: 'Kultur', 
	title: 'Karnevalstar - Brasilien'
	},	
	{ id: '40', 
	imageName: 'People/Alter_Mann-Ecuador.jpg',
	tag: 'Kultur', 
	title: 'Alter_Mann - Ecuador'
	},
	{ id: '41', 
	imageName: 'People/Kind-Ecuador.jpg',
	tag: 'Kultur', 
	title: 'Kind - Ecuador'
	},
	{ id: '42', 
	imageName: 'People/Kind2-Ecuador.jpg',
	tag: 'Kultur', 
	title: 'Kind - Ecuador'
	},
	{ id: '43', 
	imageName: 'People/Tango-Argentinien.jpg',
	tag: 'Kultur', 
	title: 'Tango - Argentinien'
	},
	{ id: '44', 
	imageName: 'People/Indios-Peru.jpg',
	tag: 'Kultur', 
	title: 'Indios - Peru'
	},
	{ id: '45', 
	imageName: 'People/Machu_Picchu-Peru.jpg',
	tag: 'Kultur', 
	title: 'Machu_Picchu - Peru'
	},
	{ id: '46', 
	imageName: 'People/Montevideo-Uruguay.jpg',
	tag: 'Kultur', 
	title: 'Montevideo - Uruguay'
	},
	{ id: '47', 
	imageName: 'People/Felsenkirche_Helsinki.jpg',
	tag: 'Kultur', 
	title: 'Felsenkirche Helsinki'
	},
	{ id: '48', 
	imageName: 'People/Felsenkirche_Helsinki2.jpg',
	tag: 'Kultur', 
	title: 'Felsenkirche_Helsinki'
	},
	{ id: '49', 
	imageName: 'People/Finnlandia_Halle_Helsinki.jpg',
	tag: 'Kultur', 
	title: 'Finnlandia Halle - Helsinki'
	},
	{ id: '50', 
	imageName: 'People/Parlament_Schottland.jpg',
	tag: 'Kultur', 
	title: 'Parlament - Schottland'
	},
	{ id: '51', 
	imageName: 'People/Parlament_Schottland2.jpg',
	tag: 'Kultur', 
	title: 'Parlament - Schottland'
	},
	{ id: '52', 
	imageName: 'People/La_Perla_Island.jpg',
	tag: 'Kultur', 
	title: 'La Perla - Island'
	},
	{ id: '53', 
	imageName: 'People/Marrakesch.jpg',
	tag: 'Kultur', 
	title: 'Marrakesch'
	},
	{ id: '54', 
	imageName: 'People/Museum_Spitzbergen.jpg',
	tag: 'Kultur', 
	title: 'Museum - Spitzbergen'
	},
	{ id: '55', 
	imageName: 'People/Palmyra-Syrien.jpg',
	tag: 'Kultur', 
	title: 'Palmyra - Syrien'
	},
	{ id: '56', 
	imageName: 'People/Pawlowsk_Palast.jpg',
	tag: 'Kultur', 
	title: 'Pawlowsk - Palast'
	},
	{ id: '57', 
	imageName: 'People/Peterhof.jpg',
	tag: 'Kultur', 
	title: 'Peterhof'
	},
	{ id: '58', 
	imageName: 'People/Petra-Jordanien.jpg',
	tag: 'Kultur', 
	title: 'Petra:Jordanien'
	},
	{ id: '59', 
	imageName: 'People/Schafe_Kurische_Nehrung.jpg',
	tag: 'Kultur', 
	title: 'Schafe - Kurische Nehrung'
	},
	{ id: '60', 
	imageName: 'People/Stockholm.jpg',
	tag: 'Kultur', 
	title: 'Stockholm'
	},
	{ id: '61', 
	imageName: 'People/Tallinn.jpg',
	tag: 'Kultur', 
	title: 'Tallinn'
	}
]